import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/applications/manual-voucher-approval')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
